import {
  setCookie
} from "./set-cookie.js";

export const deleteCookie = (name, preventSecure = false) => {
  setCookie(name, ``, {
    "max-age": -1
  }, preventSecure);
};
